var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"col col-lg-12 m-1",on:{"click":_vm.scoringRequested}},[_vm._v(" "+_vm._s(_vm.round.name)+" "),_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.round.score))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }